import React from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function PersonnelSupportModal({
  isOpen,
  lineManager,
  onClose,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const lineManagerEmail = lineManager?.attributes.email;

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton color='blue' onClick={onClose} size='md'>
            {i18nTShared('close')}
          </TextButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nTShared('support')}
          </h2>
        </div>
        <div className='modalbox-body'>
          {lineManagerEmail && (
            <>
              <p className='tw-mb-0 tw-font-semibold'>
                {i18nTShared('spottedSomethingIncorrect')}
              </p>
              <p>
                <Trans
                  components={{
                    a: (
                      /* eslint-disable jsx-a11y/anchor-has-content */
                      <a
                        className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                        href={`mailto:${lineManagerEmail}`}
                      />
                      /* eslint-enable jsx-a11y/anchor-has-content */
                    ),
                  }}
                  i18nKey='training.recommendReachingOut'
                  ns='common'
                  tOptions={{ interpolation: { escapeValue: false } }}
                  values={{
                    email: lineManagerEmail,
                    name: personDisplayName({
                      attributes: lineManager.attributes,
                    }),
                  }}
                />
              </p>
            </>
          )}
          <p className='tw-mb-0 tw-font-semibold'>
            {i18nTShared('havingTechnicalIssues')}
          </p>
          <p className='tw-mb-0'>
            <Trans
              components={{
                a: (
                  /* eslint-disable jsx-a11y/anchor-has-content */
                  <a
                    className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                    href='https://intercom.help/hands-hq/en/articles/10213935-new-viewing-your-training-profile'
                    target='blank'
                  />
                  /* eslint-enable jsx-a11y/anchor-has-content */
                ),
              }}
              i18nKey='training.profileHelp'
              ns='common'
            />
          </p>
        </div>
      </>
    </ModalBox>
  );
}

PersonnelSupportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  lineManager: resourceShape('personnel'),
  onClose: PropTypes.func.isRequired,
};
